
<div class="overlay">
  <app-spinner class="spinner"></app-spinner>
</div>